import React, { useEffect, useState } from "react";
import { getAllBanners } from "../../Api/Api";

const Banner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadBanners = async () => {
      setLoading(true);
      setError(false);
      try {
        const res = await getAllBanners();
        setBanners(Array.isArray(res) ? res : []);
      } catch (err) {
        console.error("Failed to load banners", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    loadBanners();
  }, []);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-3 gap-3 sm:gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl bg-gray-100 animate-pulse"
            />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="border border-red-100 bg-red-50 p-5 text-center text-sm font-medium text-red-600">
          Couldn't load offers right now — please refresh.
        </div>
      </div>
    );
  }

  if (!banners.length) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-2">
      <div className="mb-7 flex items-end justify-between gap-4 border-b border-gray-200 pb-5">
        <div>
          <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-[#AF7D23] sm:text-xs">
            Our current edit
          </p>
          <h2 className="text-2xl font-semibold tracking-[-0.02em] text-[#0D004C] sm:text-3xl">
            Offers worth coming home to
          </h2>
        </div>
        <span className="hidden text-right text-xs uppercase tracking-[0.16em] text-gray-400 sm:block">
          03 / 03
        </span>
      </div>

      <div className="grid grid-cols-3 gap-3 sm:gap-5">
        {banners.slice(0, 3).map((banner, index) => (
          <a
            key={banner.id || index}
            href={banner.link || undefined}
            aria-label={banner.title || `Open offer ${index + 1}`}
            className="group relative block aspect-[4/3] w-full overflow-hidden rounded-[1.25rem] border border-black/5 bg-gray-100 shadow-[0_10px_30px_rgba(13,0,76,0.07)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_45px_rgba(13,0,76,0.16)] focus:outline-none focus:ring-2 focus:ring-[#0D004C] focus:ring-offset-2"
          >
            <img
              src={`https://skishore.in/api/public/${banner.image}`}
              alt={banner.title || `Offer banner ${index + 1}`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              loading="lazy"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-[#08102f]/90 via-[#0D004C]/10 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100" />
          </a>
        ))}
      </div>
    </section>
  );
};

export default Banner;